export default "__VITE_ASSET__m0zHpy7Y__"